import axios from "axios";
import { PbxProtocol } from "@/config";
import vueApp from "@/store";

/**
 * Auth axios instance logic, is not included with the interceptors as it requires the token to intercept
 * the HTTP petion and initially it hasn't been set on the local storage
 * <This instance won't have interceptors to be able to logg in and therefore set the token>
 */
export const authApi = axios.create({
  // withCredentials: false,
});

authApi.interceptors.request.use((config) => {
  config.baseURL = `${vueApp.state.auth_store.userInfo.PbxServer}`
  return config;
});
/**
 * Main axios instance for all HTTP petitions within the SipMovil app
 * <This istance will have interceptors>
 */
export const apiClientPbx = axios.create({
  // baseURL:'http://localhost:8001', 
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: false,
});

/**
 * Add interceptors to verify whether the Authorization header contains
 * the token in every single request
 */
apiClientPbx.interceptors.request.use((config) => {
  config.baseURL = `${PbxProtocol}://${vueApp.state.auth_store.userInfo.PbxServer}`;
  // config.baseURL = 'http://localhost:8001';
    config.headers = {
      Authorization: "token " + vueApp.state.auth_store.userInfo.Token,
  };
  return config;
});
